import { Flex } from 'antd';
import styles from './section-wrapper.module.scss';
import { Link } from 'react-router-dom';
import Icon from '@ant-design/icons';
import ChevronRight from '@/assets/icons/chevron-right.svg?react';
interface SectionWrapperProps {
  title: string;
  link?: string;
}

export default function SectionWrapper({ title, link }: SectionWrapperProps) {
  return (
    <Flex className={styles.sectionWrapperHeader}>
      <span>{title}</span>
      {link && (
        <Link className={styles.sectionWrapperViewMore} to={link}>
          View more{' '}
          <Icon component={() => <ChevronRight fill="none" />} style={{ fontSize: '16px' }} />
        </Link>
      )}
    </Flex>
  );
}
